import React from 'react';
import Location from '../components/Location'
import AddLocation from '../components/AddLocation'

function Main() {
  return (
      <>
          < AddLocation />
          < Location />
      </>
  );
}

export default Main;
